import React from 'react';
import { IconButton } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';

interface ExpandIndicatorProps {
  isExpanded: boolean;
  onClick: (event: React.MouseEvent) => void;
  teamName?: string;
}

export const ExpandIndicator: React.FC<ExpandIndicatorProps> = ({
  isExpanded,
  onClick,
  teamName
}) => {
  return (
    <IconButton
      onClick={onClick}
      size="small"
      aria-expanded={isExpanded}
      aria-label={`${isExpanded ? 'Collapse' : 'Expand'} matches for ${teamName || 'team'}`}
      sx={{
        minWidth: 24,
        minHeight: 24,
        width: 24,
        height: 24,
        transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
        transition: 'transform 0.3s ease',
        '&:hover': {
          bgcolor: 'action.hover'
        }
      }}
    >
      <ChevronRight fontSize="small" />
    </IconButton>
  );
};
